import React, { CSSProperties, useEffect } from 'react';
import styles from './index.module.less';
import { Spin } from '@arco-design/web-react';
import { useSafeState } from 'ahooks';

interface IProps {
  loading?: boolean;
  style?: CSSProperties;
  backgroundColor?: string;
  limit?: boolean; // 是否限制200秒后才展示loading
}
const LoadingView = React.memo((props: IProps) => {
  const { loading, style, limit = true, backgroundColor = '#F2F3F5' } = props;
  const [showSpin, setShowSpin] = useSafeState(false);
  useEffect(() => {
    /** 超过200秒才展示，防止闪动 */
    let timer: NodeJS.Timeout | null = null;
    if (loading) {
      if (limit) {
        setShowSpin(false);
        timer = setTimeout(() => {
          setShowSpin(true);
        }, 200);
      } else {
        setShowSpin(true);
      }
    } else {
      setShowSpin(false);
    }
    return () => {
      timer && clearTimeout(timer);
    };
  }, [loading, limit]);
  return loading ? (
    <div
      className={styles.loading_view}
      style={{ backgroundColor: backgroundColor, ...style }}
    >
      <div style={{ flex: 1 }} />
      {showSpin && (
        <>
          <Spin />
        </>
      )}
      <div style={{ flex: 1 }} />
    </div>
  ) : null;
});
export default LoadingView;
